module.exports = __webpack_public_path__ + "img/antes_despues_68.956c656d.png";